import { RoomSimplified } from "./Room";
import { User, UserSimplified } from "./User";
import { BotType, SoribotSubType, TextEmbedder } from "./local/Types";

export class BaseBot {
  public id: string = 'override';
  public name: string = 'override';
  public description: string = '';
  constructor(public type: BotType) {
  }
}

export class Soribot extends BaseBot {
  static COL = 'soribots';
  static DEFAULT_IMAGE_URL = `/assets/img/ai-soribot.png`;

  public userIds: string[] = [];  // For firestore filter and security. Update when room changes.
  public roomIds: string[] = [];  // For firestore filter.  Update when room changes.
  public rooms: RoomSimplified[] = [];      // For presentation.  Update when room changes.

  public welcomeMessage: string | null = null;
  public systemInstruction: string | null = null;
  public vectorServerIP?: string;
  public llmModelName: string = 'gpt-3.5-turbo';
  public llmTemperature: number = 0.0;
  public useNoChunks?: number; // Use Nr Of Chunks
  public imageUrl: string | null = null;
  public created: Date = new Date();
  public updated: Date = new Date();
  public promptTemplate: string | null = null;
  public subType?: SoribotSubType = 'retrieval'; // Undefined => retrieval.
  public owner: UserSimplified;
  public enabledPublicPage?: boolean;
  public embeddingModel?: TextEmbedder = 'text-embedding-ada-002'; // undefined equals text-embedding-ada-002

  // Broker child bots
  public childBots: ChildBot[] = [];  // For presentation.
  public childBotIds: string[] = [];  // For firestore filter.

  public style?: PublicStyle = 'default-style';

  constructor(id: string, name: string, public workspaceId: string, owner: User) {
    super('ai-soribot');
    this.id = id;
    this.name = name;
    this.owner = { id: owner.id, name: owner.name, email:owner.email, photoUrl: owner.photoUrl };
    this.userIds = [owner.id];
  }

  static toSimplified(b: Soribot): SoribotSimplified {
    return new SoribotSimplified(b.id, b.name, b.imageUrl, b.welcomeMessage, b.childBots, b.style ?? 'default-style');
  }

  static toChildbot(b: Soribot): ChildBot {
    return new ChildBot(b.id, b.name, b.imageUrl, b.welcomeMessage, b.description);
  }
}

export class SoribotSimplified {
  constructor(public id: string, public name: string, public imageUrl: string | null, public welcomeMessage: string | null, public childBots: ChildBot[] = [], public style: PublicStyle) {
  }
}

export class ChildBot {
  constructor(public id: string, public name: string, public imageUrl: string | null, public welcomeMessage: string | null, public scope: string | null) {
  }
}

// Create/Edit via functions only.
// Should only have one page per soribot.
export class SoribotPage {
  static COL = 'soribotpages';
  public id: string;
  public enabled = true;
  public passcode: string = "";

  constructor(public soribotId: string, public publicId: string) {
    this.id = soribotId;
  }
}

export class SoribotAPIKey {
  static SUBCOL = 'soribotapikeys'; // soribots/id/soribotapikeys
  public created: Date = new Date();
  public title?: string;
  constructor(public id: string, public soribotId: string, public key: string) {
  }
}

export type PublicStyle = 'default-style' | 'bubble-style';